module.exports = __webpack_public_path__ + "submenu_award_0.00881bdb.png";